import { eAtlas, eUIAtlasFrame, Game } from "../../../../Game";
import { AtlasUtils } from "../../../../Utils/Atlas/AtlasUtils";
import { FireBallBar } from "../../Arc8/Status bar/FireBallBar";
import { LifeBar } from "../../Arc8/Status bar/LifeBar";



export class StatusBar {
    static readonly CONTAINER_W = 586;
    static readonly CONTAINER_H = 82;

    private _container: pc.Entity;

    private _lifeBar: LifeBar;
    private _fireBallBar: FireBallBar;

    get visible(): boolean { return this._visible; }
    set visible(val: boolean) {
        if (val != this._visible) {
            this._visible = val;
            this._container.enabled = val;
        }
    }
    private _visible: boolean = true;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(parent: pc.Entity) {
        // Bargroup
        let batchGroupId = Game.app.batcher.addGroup("stBar", true, 100, undefined, [Game.app.scene.layers.getLayerByName("UI").id]).id;

        // Pozadi status baru
        let atlas = Game.getAtlas(eAtlas.texts);
        let texture = atlas.texture;
        let frameRc = (<pc.TextureAtlasFrame>atlas.frames[eUIAtlasFrame.stBarBg + "_1"]).rect;

        let rc = AtlasUtils.getTexFrameRegion(texture, frameRc);

        this._container = new pc.Entity("stBar");
        this._container.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: texture,
            width: StatusBar.CONTAINER_W,
            height: StatusBar.CONTAINER_H,
            anchor: [0.5, 1, 0.5, 1],
            pivot: [0.5, 1],
            rect: rc,
            //batchGroupId: batchGroupId
        });
        this._container.setLocalPosition(0, -76, 0);
        parent.addChild(this._container);

        // Zbyvajici pocet zivotu
        this._lifeBar = new LifeBar(this._container, batchGroupId);

        // Stav golden ballu
        this._fireBallBar = new FireBallBar(this._container, batchGroupId);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._lifeBar.reset();
        this._fireBallBar.reset();

        this.visible = true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        this._lifeBar.update();
        this._fireBallBar.update();
    }
}